<div class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
    </div>
    <span class="page-title">Create New OTA Batch</span>
  </div>

  @if (viewOta && createOta) {
    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">OTA Batch Details</h6>
        <div class="component-actions">
          <button class="primary-button" (click)="downloadMyFile()">
            Download Sample<mat-icon class="btn-icon">download</mat-icon>
          </button>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body" [formGroup]="ParametersListForm">
        <div class="form-section">
          <div class="form-group">
            <label for="" class="form-label">Batch Name</label>
            <mat-form-field class="form-group" appearance="outline">
              <mat-label>Batch Name</mat-label>
              <input
                matInput
                type="text"
                formControlName="batchName"
                placeholder="Batch Name"
              />
              @if (
                ParametersListForm.controls['batchName'].touched &&
                ParametersListForm.controls['batchName'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    ParametersListForm.controls['batchName']?.errors
                      ?.requiredAndNoEmptySpaces
                  }}</mat-error
                >
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="batchDescription" class="form-label"
              >Batch Description</label
            >
            <mat-form-field class="form-group" appearance="outline">
              <mat-label>Batch Description</mat-label>
              <input
                matInput
                type="text"
                formControlName="batchDescription"
                placeholder="Batch Description"
              />
              @if (
                ParametersListForm.controls['batchDescription'].touched &&
                ParametersListForm.controls['batchDescription'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    ParametersListForm.controls['batchDescription']?.errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="file" class="form-label">Upload File</label>
            <mat-form-field class="file-upload-container" appearance="outline">
              <mat-label>Upload File</mat-label>

              <!-- Display File Name or Placeholder -->
              <input matInput type="text" formControlName="fileName" readonly />

              <!-- Hidden File Input -->
              <input
                type="file"
                accept=".csv"
                aria-label="File"
                class="d-none"
                (change)="onFileSelected($event)"
                #otaDeviceFile
              />

              <!-- Custom Upload Button -->
              <button
                mat-button
                class="upload-btn"
                (click)="otaDeviceFile.click()"
                type="button"
              >
                <mat-icon>attach_file</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="component-container">
      <div class="component-header" [formGroup]="searchForm">
        <h6 class="component-title">OTA Command List</h6>
        <div class="component-actions">
          <app-common-component-dropdown-search
            [items]="otaTypeList"
            [placeHolder]="'Select OTA Type'"
            [initialValue]="this.otaCommandType"
            (itemSelected)="onStatusSelect($event)"
          ></app-common-component-dropdown-search>
          <app-common-search
            formControlName="searchInput"
            (searchSubmit)="onSearch($event)"
          ></app-common-search>
        </div>
      </div>
      <div class="component-separator"></div>
      <div class="component-body">
        @if (commandArray.length > 0) {
          <div class="ota-form-section">
            @for (item of commandArray; track item) {
              <div class="border">
                <mat-checkbox
                  (change)="addToCheckedArray($event, item)"
                  [checked]="checkChecked(item)"
                  [id]="'flexCheckDefault' + item.name"
                >
                  {{ item.name }}
                </mat-checkbox>
              </div>
            }
          </div>
        } @else {
          <table>
            <tr>
              <td>
                <img
                  class="img-fluid"
                  src="../../assets/dataNotFound.jpg"
                  alt="No Data Found"
                />
              </td>
            </tr>
          </table>
        }
      </div>
      @if (checkedArr.length > 0) {
        <div class="component-separator"></div>
        <div class="component-footer">
          <div class="button-group">
            <button class="submit-button" (click)="SubmitBatch()">
              Set Batch<mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
    @if (config && checkedArr.length > 0) {
      <div class="componenet-container">
        <div class="component-header">
          <h6 class="component-title">Set Configuration Value</h6>
          <div class="component-actions"></div>
        </div>
        <div class="component-separator"></div>
        <div class="component-body" [formGroup]="CommondForm">
          <table>
            <tr>
              <th>Name</th>
              <th>Command</th>
              <th>Example</th>
              <th>Input Value</th>
              <th>Action</th>
            </tr>
            <tbody>
              @for (item of otaListSelected; track item) {
                <tr>
                  <td>
                    {{ item.name }}
                  </td>
                  <td>
                    {{ item.otaCommand }}
                  </td>
                  <td>
                    {{ item.example }}
                  </td>
                  <td class="form-section">
                    @if (item.inputRequired?.toUpperCase() === 'YES') {
                      <div class="form-group">
                        <mat-form-field class="form-field" appearance="outline">
                          <input
                            type="text"
                            matInput
                            placeholder="Please Enter Input Value"
                            aria-label="Input Value"
                            formControlName="{{ item.id }}"
                          />
                          @if (
                            CommondForm.controls[item.id]?.touched &&
                            CommondForm.controls[item.id]?.errors?.[
                              'requiredAndNoEmptySpaces'
                            ]
                          ) {
                            <mat-error>
                              {{
                                CommondForm.controls[item.id]?.errors
                                  ?.requiredAndNoEmptySpaces
                              }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    }
                    @if (item.inputRequired?.toUpperCase() === 'NO') {
                      <div class="form-group">
                        <mat-form-field class="form-field" appearance="outline">
                          <input
                            matInput
                            type="text"
                            placeholder="No Input Value Required"
                            aria-label="Input Value"
                            formControlName="{{ item.id }}"
                            readonly
                          />
                        </mat-form-field>
                      </div>
                    }
                  </td>
                  <td>
                    <div class="action-buttons">
                      <button
                        class="primary-button delete-button"
                        (click)="deleteCommand(item.id)"
                      >
                        <mat-icon class="btn-icon">delete</mat-icon>
                      </button>
                      <button
                        class="primary-button export-button"
                        (click)="clearCommand(item.id)"
                      >
                        <mat-icon class="btn-icon">backspace</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          <div class="button-group">
            <button class="submit-button" (click)="submit()">
              Submit <mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          </div>
        </div>
      </div>
    }
  }
</div>
